export default __webpack_public_path__ + "static/media/logo.c41af097.png";